import React, { Component } from 'react'
import { Col, Row } from 'reactstrap';

export default class AccessDenied extends Component {
  render() {
    return (
      <div>
        <Row>
            <Col>
                <h2>Access Denied</h2>
                <p>You are not authorized to access this page.</p>
            </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/access_denied.js